import axios_instance from '../utilities/axios_instance';
const AOI_CLASSIFICATION_SERVICE_URL = process.env.REACT_APP_AOI_CLASSIFICATION_SERVICE_URL;

const AOIHistoryService = {
  getAOIHistory: async (geometry) => {
    try {
      const response = await axios_instance.post('data/aoi/history', {
        geometry: geometry
      });
      return response.data?.data || response.data;
    } catch (error) {
      console.error('Error fetching AOI history:', error);
      throw error;
    }
  },

  classifyAOIHistory: async (geometry, history) => {
    try {
      const response = await axios_instance.post(`${AOI_CLASSIFICATION_SERVICE_URL}/classify`, {
        geometry,
        history
      });
      return response.data;
    } catch (error) {
      console.error('Error classifying AOI history:', error);
      throw error;
    }
  }
};

export default AOIHistoryService;
